var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrabal = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.01 6.55a5.605 5.605 0 0 0-4.57-4.57V.06a7.501 7.501 0 0 1 6.49 8.39H8.44v-1.9h4.57Z",
  fill: "#D21918"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.55 1.98a5.605 5.605 0 0 0-4.57 4.57H.06A7.501 7.501 0 0 1 8.45.06v6.49h-1.9V1.98Z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.98 8.45a5.605 5.605 0 0 0 4.57 4.57v1.92A7.501 7.501 0 0 1 .06 6.55h6.49v1.9H1.98Z",
  fill: "#E0E0E0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.44 13.02a5.605 5.605 0 0 0 4.57-4.57h1.92a7.501 7.501 0 0 1-8.39 6.49V8.45h1.9v4.57Z",
  fill: "#FFE041"
})));
export default SvgTrabal;